import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext, PaddedContainer, RootWrapperContainer } from "../../App";

import Styled from "./FunctionDetailsContainerStyles";

import {
  Color,
  ColorSAP,
  Delete,
  FONT_FAMILY,
  Search,
  Typography,
} from "../../ontego-ui";

import {
  ArrowLeft,
  ArrowRight,
  CollectionAdded,
  Copy,
  ProcessOverview,
} from "../../ontego-ui/sap_icons";

import DeleteIconButton from "../../ReusableComponents/DeleteIconButton";
import FunctionTypeChips from "../../ReusableComponents/FunctionTypeChips";

import DeleteDialog from "../../Dialogs/DeleteDialog/DeleteDialog";
import SpecialFunctionDialog from "../../Dialogs/SpecialFunctionDialog/SpecialFunctionDialog";
import FunctionLists from "./FunctionLists";

import Cart from "../../Models/Cart";
import CartProcess from "../../Models/CartProcess";

import { SCENARIO_PATH } from "../../Constants/Path";
import mobilePlaceholder from "../../assets/img/apppreview/mobile_placeholder.png";
import desktopPlaceholder from "../../assets/img/apppreview/desktop_placeholder.png";
import tabletPlaceholder from "../../assets/img/apppreview/tablet_placeholder.png";

import {
  convertNotesToEditorState,
  convertNotesToJSON,
  isProcessAlreadyAddedToCollection,
  isProcessTypeAlreadyAddedToCollection,
} from "../../Utils/Utils";

import { useTranslation } from "react-i18next";

import AppService from "../../AppService";
import {
  F_AUSLAGERUNG,
  F_BESTANDSINFO,
  F_BESTELLERFASSUNG,
  F_CHECKLISTE_MOBILE_WAREHOUSE_LOGISTICS_SOLUTIONS,
  F_CHECKLISTE_PLANT_MAINTENANCE,
  F_DUMMY_MOBILE_WAREHOUSE_LOGISTICS_SOLUTIONS,
  F_EINLAGERUNG,
  F_INVENTUR,
  F_INVENTUR_LEITSTAND,
  F_KANBAN,
  F_KOMMISSIONIERUNG,
  F_PLANT_MAINTENANCE_INFOSYSTEM,
  F_PLANT_MAINTENANCE_PLANMASSIGE,
  F_PLANT_MAINTENANCE_REAKTIVE,
  F_PRODUKTIONSVERSORGUNG,
  F_QUALITAETSKONTROLLE,
  F_RUECKMELDUNG_PRODUKTION,
  F_SONDERFUNKTIONEN_ERWEITERUNGEN,
  F_UMBUCHUNG,
  F_UMLAGERUNG,
  F_VERLADUNG,
  F_VERPACKUNG,
  F_WARENAUSGANG_EXTERN,
  F_WARENAUSGANG_INTERN,
  F_WARENEINGANG,
} from "../../Constants/FunctionIds";
import {
  getFunctionIconFromId,
  getTypeOfFunction,
} from "../../Utils/FunctionUtils";
import FunctionService from "./FunctionService";

import { FUNCTION_SONDERFUNKTIONEN_ERWEITERUNGEN } from "../../Constants/FunctionCollection";

import Breadcrumb from "../../ReusableComponents/Breadcrumb/Breadcrumb";
import SAPNavHeader from "../../ReusableComponents/SAPNavHeader/SAPNavHeader";
import Button from "../../ReusableComponents/Button/Button";
import Carousel from "../../ReusableComponents/Carousel/Carousel";
import Drawer from "../../ReusableComponents/Drawer/Drawer";
import Form from "../../ReusableComponents/Form/Form";

// import { convertFromRaw, convertToRaw, EditorState } from 'draft-js'
import Tooltip from "../../ReusableComponents/Tooltip/Tooltip";
import useScreenSize from "../../Utils/useScreenSize";

import { Dialog } from "@mui/material";
import CloseNew from "../../Icons/CloseNew";
import FullscreenIcon from "../../Icons/Fullscreen";
import { Loading } from "../../ontego-ui";

const DEVICE_CONFIG = {
  mobile: {
    containerWidth: null,
    frameWidth: 200,
    frameHeight: 401,
    placeholder: mobilePlaceholder,
    screenshotTop: 66,
    screenshotLeft: 21,
    screenshotTransform: "none",
    screenshotWidth: 159,
    screenshotHeight: 283,
    dialogScale: 1.4,
  },
  desktop: {
    containerWidth: 340,
    frameWidth: 340,
    frameHeight: 262,
    placeholder: desktopPlaceholder,
    screenshotTop: 7,
    screenshotLeft: "50%",
    screenshotTransform: "translateX(calc(-50% - 0.5px))",
    screenshotWidth: 325,
    screenshotHeight: 182,
    dialogScale: 2.2,
  },
  tablet: {
    containerWidth: 340,
    frameWidth: 340,
    frameHeight: 215,
    placeholder: tabletPlaceholder,
    screenshotTop: 22,
    screenshotLeft: "50%",
    screenshotTransform: "translateX(calc(-50% - 0.5px))",
    screenshotWidth: 281,
    screenshotHeight: 175,
    dialogScale: 2.3,
  },
};

const AppPreview = (props) => {
  const {
    inspectedFunctionImage,
    activeData,
    appPreviewNavIndex,
    setAppPreviewNavIndex,
    handleCarouselNavOnClick,
    handleLeftArrowOnClick,
    handleRightArrowOnClick,
    isOpen,
    setIsOpen,
  } = props;

  const { t } = useTranslation();
  const [isImageLoading, setIsImageLoading] = useState(false);

  // Function to preload image and handle loading state
  const preloadImage = (imageSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = imageSrc;

      // If image is already cached, resolve immediately
      if (img.complete) {
        resolve(img);
      }
    });
  };

  // Handle image loading when carousel index changes
  useEffect(() => {
    if (
      inspectedFunctionImage &&
      activeData &&
      typeof inspectedFunctionImage.filter(
        (inspectedImage) =>
          inspectedImage.id ===
          activeData.dataType[activeData.activeIndex].systemID,
      )[0] !== "undefined"
    ) {
      const currentImageData = inspectedFunctionImage.filter(
        (inspectedImage) =>
          inspectedImage.id ===
          activeData.dataType[activeData.activeIndex].systemID,
      )[0];
      if (currentImageData && currentImageData.images[appPreviewNavIndex]) {
        const imageSrc = currentImageData.images[appPreviewNavIndex].image;
        if (imageSrc) {
          setIsImageLoading(true);
          preloadImage(imageSrc)
            .then(() => {
              setIsImageLoading(false);
            })
            .catch(() => {
              setIsImageLoading(false);
            });
        }
      }
    }
  }, [appPreviewNavIndex, inspectedFunctionImage, activeData]);

  let imagesLength = 0;
  let shownImage = "";
  const showButton = true;
  let shownImageName = "";
  let showCarousel = false;
  let imagePosition = null;
  let currentImage = null;

  if (
    inspectedFunctionImage &&
    typeof inspectedFunctionImage.filter(
      (inspectedImage) =>
        inspectedImage.id ===
        activeData.dataType[activeData.activeIndex].systemID,
    )[0] !== "undefined"
  ) {
    const currentImageContainer = inspectedFunctionImage.filter(
      (inspectedImage) =>
        inspectedImage.id ===
        activeData.dataType[activeData.activeIndex].systemID,
    )[0];
    imagesLength = currentImageContainer.images.length;
    if (imagesLength > 0) {
      if (
        typeof currentImageContainer.images[appPreviewNavIndex] !== "undefined"
      ) {
        currentImage = currentImageContainer.images[appPreviewNavIndex];
        showCarousel = true;
        imagePosition = currentImage.position;
        shownImage = currentImage.image;
        shownImageName = currentImage.name;
      } else {
        currentImage = currentImageContainer.images[0];
        showCarousel = true;
        shownImage = currentImage.image;
        shownImageName = currentImage.name;
        setAppPreviewNavIndex(0);
      }
    }
  }

  // Detect device type from the currently viewed image
  let deviceType = "mobile";
  if (currentImage) {
    if (currentImage.isDesktop) deviceType = "desktop";
    else if (currentImage.isTablet) deviceType = "tablet";
  }
  const device = DEVICE_CONFIG[deviceType];

  if (imagesLength === 0) {
    return null;
  }

  return (
    <>
      <Styled.AppPreviewContainer
        style={device.containerWidth ? { width: device.containerWidth } : {}}
      >
        <Styled.ClickToPreview>
          <Button
            type="secondary"
            size="small"
            theme="dark"
            icon={<FullscreenIcon />}
            onClick={() => setIsOpen(true)}
          >
            {t("functionDetails.buttonAppPreview")}
          </Button>
        </Styled.ClickToPreview>
        {imagesLength > 0 && (
          <Styled.AppPreviewWrapper>
            {appPreviewNavIndex > 0 && imagesLength > 1 && (
              <Styled.CarouselArrowLeft
                isDisabled={appPreviewNavIndex <= 0}
                onClick={handleLeftArrowOnClick}
              >
                <ArrowLeft />
              </Styled.CarouselArrowLeft>
            )}
            <Styled.AppPreviewImageContainer
              style={
                device.containerWidth ? { width: device.containerWidth } : {}
              }
            >
              <div
                style={{
                  position: "relative",
                  width: device.frameWidth,
                  height: device.frameHeight,
                  margin: "0 auto",
                }}
              >
                <img
                  src={device.placeholder}
                  alt={deviceType}
                  style={{
                    width: device.frameWidth,
                    height: device.frameHeight,
                    display: "block",
                  }}
                />
                <img
                  style={{
                    position: "absolute",
                    top: device.screenshotTop,
                    left: device.screenshotLeft,
                    transform: device.screenshotTransform,
                    width: device.screenshotWidth,
                    height: device.screenshotHeight,
                    objectFit: "cover",
                    objectPosition: imagePosition,
                    opacity: isImageLoading ? 0 : 1,
                  }}
                  src={shownImage}
                  alt={shownImageName}
                />
                {isImageLoading && (
                  <Styled.ImageLoadingOverlay
                    style={{
                      position: "absolute",
                      top: device.screenshotTop,
                      left: device.screenshotLeft,
                      transform:
                        deviceType !== "mobile" ? "translateX(-50%)" : "none",
                      width: device.screenshotWidth,
                      height: device.screenshotHeight,
                      borderRadius: 0,
                      background: "rgba(0, 0, 0, 0.5)",
                      maxWidth: "none",
                      maxHeight: "none",
                    }}
                  >
                    <Loading
                      style={{
                        width: 48,
                        height: 48,
                        color: ColorSAP.primary[40],
                      }}
                    />
                  </Styled.ImageLoadingOverlay>
                )}
                {/* Old preview button inside phone mockup:
                {showButton && !isImageLoading && (
                  <Styled.ButtonPreviewContainer>
                    <Button
                      type="primary"
                      theme="dark"
                      size="small"
                      icon={<FullscreenIcon />}
                      onClick={() => setIsOpen(true)}
                    >
                      {t("functionDetails.buttonAppPreview")}
                    </Button>
                  </Styled.ButtonPreviewContainer>
                )}
                */}
              </div>
              <Styled.AppPreviewTextContainer>
                <Typography
                  fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
                  size={12}
                  color={ColorSAP.neutral[50]}
                  style={{
                    marginRight:
                      activeData.dataType[activeData.activeIndex].type.length >
                        0 && 8,
                  }}
                >
                  {shownImageName}
                </Typography>
                <FunctionTypeChips
                  type={activeData.dataType[activeData.activeIndex].type}
                />
              </Styled.AppPreviewTextContainer>
            </Styled.AppPreviewImageContainer>
            {appPreviewNavIndex !== imagesLength - 1 && imagesLength > 1 && (
              <Styled.CarouselArrowRight
                isDisabled={appPreviewNavIndex + 1 === imagesLength}
                onClick={handleRightArrowOnClick}
              >
                <ArrowRight />
              </Styled.CarouselArrowRight>
            )}
            {showCarousel && imagesLength > 1 && (
              <Styled.CarouselContainer>
                <Carousel
                  length={imagesLength}
                  index={appPreviewNavIndex}
                  onClick={handleCarouselNavOnClick}
                />
              </Styled.CarouselContainer>
            )}
          </Styled.AppPreviewWrapper>
        )}
      </Styled.AppPreviewContainer>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth={"xl"}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.65)",
            },
          },
          paper: {
            sx: {
              backgroundColor: "transparent",
              boxShadow: "none",
              borderRadius: 0,
              maxHeight: "unset",
              overflow: "visible",
              alignItems: "flex-end",
            },
            elevation: 1,
          },
        }}
      >
        {appPreviewNavIndex > 0 && imagesLength > 1 && (
          <Styled.DialogCarouselArrowLeft
            isDisabled={appPreviewNavIndex <= 0}
            onClick={handleLeftArrowOnClick}
          >
            <ArrowLeft
              style={{
                marginRight: "-50px",
                width: "48px",
                height: "48px",
                fill: "#F1F2F1",
                opacity: 1,
              }}
            />
          </Styled.DialogCarouselArrowLeft>
        )}
        <Styled.DialogClose onClick={() => setIsOpen(false)}>
          <CloseNew
            style={{
              marginRight: "-125px",
              width: "48px",
              height: "48px",
              fill: "#F1F2F1",
              opacity: 1,
            }}
          />
        </Styled.DialogClose>
        <Styled.DialogImage style={{ overflow: "visible", maxHeight: "unset" }}>
          <div
            style={{
              width: device.frameWidth * device.dialogScale,
              height: device.frameHeight * device.dialogScale,
              margin: "0 auto",
            }}
          >
            <div
              style={{
                position: "relative",
                width: device.frameWidth,
                height: device.frameHeight,
                transform: `scale(${device.dialogScale})`,
                transformOrigin: "top left",
              }}
            >
              <img
                src={device.placeholder}
                alt={deviceType}
                style={{
                  width: device.frameWidth,
                  height: device.frameHeight,
                  display: "block",
                }}
              />
              <img
                style={{
                  position: "absolute",
                  top: device.screenshotTop,
                  left: device.screenshotLeft,
                  transform: device.screenshotTransform,
                  width: device.screenshotWidth,
                  height: device.screenshotHeight,
                  objectFit: "cover",
                  objectPosition: imagePosition,
                  opacity: isImageLoading ? 0 : 1,
                  transition: "opacity 0.3s ease-in-out",
                }}
                src={shownImage}
                alt={shownImageName}
              />
              {isImageLoading && (
                <Styled.DialogImageLoadingOverlay
                  style={{
                    position: "absolute",
                    top: device.screenshotTop,
                    left: device.screenshotLeft,
                    transform:
                      deviceType !== "mobile" ? "translateX(-50%)" : "none",
                    width: device.screenshotWidth,
                    height: device.screenshotHeight,
                    borderRadius: 0,
                    maxWidth: "none",
                    maxHeight: "none",
                  }}
                >
                  <Loading
                    style={{
                      width: 64,
                      height: 64,
                      color: ColorSAP.primary[40],
                    }}
                  />
                </Styled.DialogImageLoadingOverlay>
              )}
            </div>
          </div>
        </Styled.DialogImage>
        <Styled.AppPreviewTextContainer>
          <Typography
            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM}
            size={18}
            color={ColorSAP.primary[0]}
            style={{
              marginRight:
                activeData.dataType[activeData.activeIndex].type.length > 0 &&
                8,
              textShadow: "1px 1px 1px rgba(0, 0, 0, 0.60)",
            }}
          >
            {shownImageName}
          </Typography>
          <FunctionTypeChips
            type={activeData.dataType[activeData.activeIndex].type}
          />
        </Styled.AppPreviewTextContainer>
        {appPreviewNavIndex !== imagesLength - 1 && imagesLength > 1 && (
          <Styled.DialogCarouselArrowRight
            isDisabled={appPreviewNavIndex + 1 === imagesLength}
            onClick={handleRightArrowOnClick}
          >
            <ArrowRight
              style={{
                marginLeft: "-50px",
                width: "48px",
                height: "48px",
                fill: "#F1F2F1",
                opacity: 1,
              }}
            />
          </Styled.DialogCarouselArrowRight>
        )}
        {showCarousel && imagesLength > 1 && (
          <Styled.DialogCarouselContainer>
            <Carousel
              isDialog={true}
              length={imagesLength}
              index={appPreviewNavIndex}
              onClick={handleCarouselNavOnClick}
            />
          </Styled.DialogCarouselContainer>
        )}
      </Dialog>
    </>
  );
};

const Sidebar = (props) => {
  const { collection, inspectedFunctionId } = useContext(AppContext);

  const {
    originalMenus,
    menus,
    onSearch,
    search,
    activeOption,
    setActiveOption,
    setActiveData,
    isScrolling,
    setIsScrolling,
    setAppPreviewNavIndex,
    handleOpenSpecialFunctionDialog,
  } = props;

  const { t } = useTranslation();

  const screenSize = useScreenSize();

  return (
    <Styled.SidebarContainer>
      {originalMenus.length > 0 && (
        <Form
          placeholder={t("common.search")}
          onChange={onSearch}
          style={{ outline: "none" }}
          startAdornment={<Search />}
        />
      )}
      {menus.length > 0 && (
        <Styled.SidebarDrawerContainer
          style={{
            maxHeight: `calc(${screenSize.height - 280}px)`,
          }}
        >
          <Drawer
            inspectedFunctionId={inspectedFunctionId}
            menus={menus}
            search={search}
            activeOption={activeOption}
            setActiveOption={setActiveOption}
            setActiveData={setActiveData}
            isProcessTypeAlreadyAddedToCollection={
              isProcessTypeAlreadyAddedToCollection
            }
            collection={collection}
            isScrolling={isScrolling}
            setIsScrolling={setIsScrolling}
            setAppPreviewNavIndex={setAppPreviewNavIndex}
          />
        </Styled.SidebarDrawerContainer>
      )}
    </Styled.SidebarContainer>
  );
};

const NewFunctionButton = (props) => {
  const { onClick, size } = props;
  const { t } = useTranslation();

  return (
    <Button
      type="primary"
      theme="dark"
      size={size}
      style={{ outline: "none" }}
      onClick={onClick}
    >
      {t("functionDetails.newFunction")}
    </Button>
  );
};

const AddCollectionButton = (props) => {
  const { handleAddToCollection, activeData } = props;
  const { t } = useTranslation();

  return (
    <>
      <Button
        type="secondary"
        size="small"
        theme="dark"
        onClick={handleAddToCollection(activeData)}
      >
        {t("functionDetails.addToCollection").toUpperCase()}
      </Button>
    </>
  );
};

const RemoveCollectionButton = (props) => {
  const { handleRemoveFromCollection, activeData } = props;
  const { t } = useTranslation();

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CollectionAdded
          style={{ width: 24, height: 24, color: ColorSAP.secondary[40] }}
        />
        <Typography
          fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
          size={14}
          color={ColorSAP.neutral[100]}
          style={{ marginLeft: 8 }}
        >
          {t("functionDetails.added")}
        </Typography>
      </div>
      <Tooltip
        title={t("functionDetails.removeFromCollection")}
        placement="bottom"
      >
        <div>
          <DeleteIconButton onClick={handleRemoveFromCollection(activeData)} />
        </div>
      </Tooltip>
    </>
  );
};

const ConfigurationContainer = () => {
  const navigate = useNavigate();

  const {
    setIsFunctionLoading,
    inspectedFunctionId,
    collection,
    setCollection,
    userInfo,
    specialFunctions,
    setSpecialFunctions,
    handleShowSnackbar,
    handleShowErrorSnackbar,
    editorStateList,
    setEditorStateList,
    handleAddEditorStateList,
  } = useContext(AppContext);

  const [activeData, setActiveData] = useState(null);
  const [activeOption, setActiveOption] = useState("");

  const [inspectedFunction, setInspectedFunction] = useState(null);
  const [inspectedFunctionImage, setInspectedFunctionImage] = useState(null);
  const [searchableInspectedFunction, setSearchableInspectedFunction] =
    useState(null);

  const [appPreviewNavIndex, setAppPreviewNavIndex] = useState(0);

  const [isScrolling, setIsScrolling] = useState(false);

  const [search, setSearch] = useState("");

  const [specialFunctionDialogOpen, setSpecialFunctionDialogOpen] =
    useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [isEditingSpecialFunction, setIsEditingSpecialFunction] =
    useState(false);
  const [inspectedSpecialFunctionData, setInspectedSpecialFunctionData] =
    useState(null);

  useEffect(() => {
    if (inspectedFunction) {
      let isCancelled = false;
      let isError = false;

      const fetchData = async () => {
        if (!isCancelled) {
          const fetchedFunctionCollection =
            await AppService.getFunctionCollection(userInfo.key).catch(
              (err) => {
                console.log(err);
                isError = true;
              },
            );

          if (!isError) {
            const newEditorStateList = [...editorStateList];

            const newCollection = convertNotesToEditorState(
              fetchedFunctionCollection.data.functionCollection,
            );

            newCollection.forEach((collection) => {
              if (collection.systemID === inspectedFunction.systemID) {
                collection.processes.forEach((process) => {
                  newEditorStateList.push({
                    function_id: inspectedFunction.systemID,
                    sub_function_id: process.systemID,
                    notes: process.notes,
                  });
                });
              }
            });

            setEditorStateList(newEditorStateList);
          }
        }
      };

      fetchData();

      return () => {
        isCancelled = true;
      };
    }
  }, [inspectedFunction, collection]);

  const { t, i18n } = useTranslation();

  const handleOpenSpecialFunctionDialog = () => {
    setSpecialFunctionDialogOpen(true);
  };

  const handleCloseSpecialFunctionDialog = () => {
    setSpecialFunctionDialogOpen(false);
    setIsEditingSpecialFunction(false);
    setInspectedSpecialFunctionData(null);
  };

  const handleOpenDeleteDialog = () => {
    setDeleteDialogOpen(true);
  };
  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setInspectedSpecialFunctionData(null);
  };

  const handleDeleteSpecialFunction = () => {
    const newSpecialFunctions = { ...specialFunctions };
    const tempSpecialFunctions = JSON.parse(
      JSON.stringify(newSpecialFunctions),
    );

    const newCollection = [...collection];
    const tempCollection = JSON.parse(JSON.stringify(newCollection));

    newSpecialFunctions.data.forEach((p, j) => {
      if (
        p.name === inspectedSpecialFunctionData.name &&
        JSON.stringify(p.type) ===
          JSON.stringify(inspectedSpecialFunctionData.type)
      ) {
        newSpecialFunctions.data.splice(j, 1);
      }
    });

    if (
      isProcessAlreadyAddedToCollection(
        collection,
        inspectedSpecialFunctionData,
      )
    ) {
      newCollection.forEach((c, i) => {
        if (c.name === inspectedFunction.name) {
          c.processes.forEach((p, j) => {
            if (p.name === inspectedSpecialFunctionData.name) {
              if (
                JSON.stringify(p.type) ===
                JSON.stringify(
                  inspectedSpecialFunctionData.dataType[
                    inspectedSpecialFunctionData.activeIndex
                  ].type,
                )
              ) {
                c.processes.splice(j, 1);
              }

              if (c.processes.length === 0) {
                newCollection.splice(i, 1);
              }
            }
          });
        }
      });
    }

    AppService.updateSpecialFunctions(userInfo.key, newSpecialFunctions).then(
      (res) => setSpecialFunctions(newSpecialFunctions),
    );

    AppService.updateFunctionCollection(
      userInfo.key,
      convertNotesToJSON(newCollection),
    )
      .then((res) => {
        setCollection(convertNotesToEditorState(newCollection));
        handleShowSnackbar({
          message: t("manage.objectDeleted", {
            object: inspectedSpecialFunctionData.name,
          }),
          autoHideDuration: 5000,
          icon: <Delete />,
          showButton: true,
          buttonLabel: t("manage.undo"),
          onUndo: () => {
            setSpecialFunctions(tempSpecialFunctions);
            setCollection(tempCollection);
          },
        });
      })
      .catch((err) => {
        handleShowErrorSnackbar(err);
      });
  };

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      setIsFunctionLoading(true);

      if (inspectedFunctionId !== F_SONDERFUNKTIONEN_ERWEITERUNGEN)
        await new Promise((resolve) => setTimeout(resolve, 500));

      const fetchedFunction = await FunctionService.getFunctionData(
        inspectedFunctionId,
        i18n.language,
      ).catch((err) => {
        // Only touch state if this fetch is still the active one — a stale
        // rejection (rapid language toggle, navigation) would otherwise clear
        // the spinner for a newer, still-in-flight request. See F5 in the
        // Phase 5 code review.
        if (!isCancelled) {
          setIsFunctionLoading(false);
          handleShowErrorSnackbar(err);
        }
      });

      let newFunctionData;
      let obj = null;

      if (!isCancelled) {
        if (inspectedFunctionId === F_SONDERFUNKTIONEN_ERWEITERUNGEN) {
          newFunctionData = specialFunctions;
        } else {
          // Guard against (a) the .catch above returning undefined on any
          // rejection, and (b) the API's contractual `null` response body
          // when functionId is unknown. Either case would previously throw
          // on the spread, leaving the spinner stuck. F3 in the review.
          newFunctionData = { ...(fetchedFunction?.data ?? {}) };
        }

        // Build the image-container array from the DB-sourced images embedded
        // on each process type in the API response. Preserves the existing
        // { id, images: [{name, image}] } shape used by downstream render code.
        if (
          inspectedFunctionId !== F_SONDERFUNKTIONEN_ERWEITERUNGEN &&
          newFunctionData.data
        ) {
          obj = newFunctionData.data.flatMap((process) =>
            (process.dataType || []).map((processType) => ({
              id: processType.systemID,
              images: (processType.images || []).map((img) => ({
                name: img.name,
                image: img.path,
              })),
            })),
          );
        }

        setInspectedFunctionImage(obj);

        setInspectedFunction(newFunctionData);
        setSearchableInspectedFunction(newFunctionData);

        if (newFunctionData.data?.length > 0) {
          setActiveData(newFunctionData.data[0]);
          setActiveOption(newFunctionData.data[0].name);
        }

        setIsFunctionLoading(false);
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [inspectedFunctionId, i18n.language]);

  useEffect(() => {
    if (inspectedFunctionId === F_SONDERFUNKTIONEN_ERWEITERUNGEN)
      fetchSpecialFunctionsData();
  }, []);

  useEffect(() => {
    if (inspectedFunctionId === F_SONDERFUNKTIONEN_ERWEITERUNGEN) {
      setInspectedFunction(specialFunctions);
      setSearchableInspectedFunction(specialFunctions);
      if (specialFunctions.data.length > 0) {
        setActiveData(specialFunctions.data[specialFunctions.data.length - 1]);
        handleChangeActiveOption(
          specialFunctions.data[specialFunctions.data.length - 1],
        );
      }
    }
  }, [specialFunctions]);

  const fetchSpecialFunctionsData = () => {
    AppService.getSpecialFunctions(userInfo.key)
      .then((response) => {
        setSpecialFunctions(response.data);
      })
      .catch((err) =>
        setSpecialFunctions(FUNCTION_SONDERFUNKTIONEN_ERWEITERUNGEN),
      );
  };

  const handleCarouselNavOnClick = (index) => () => {
    if (index !== appPreviewNavIndex) {
      setAppPreviewNavIndex(index);
    }
  };

  const handleLeftArrowOnClick = () => {
    if (appPreviewNavIndex > 0) {
      setAppPreviewNavIndex(appPreviewNavIndex - 1);
    }
  };

  const handleRightArrowOnClick = () => {
    if (
      appPreviewNavIndex !==
      inspectedFunctionImage.filter(
        (inspectedImage) =>
          inspectedImage.id ===
          activeData.dataType[activeData.activeIndex].systemID,
      )[0].images.length -
        1
    ) {
      setAppPreviewNavIndex(appPreviewNavIndex + 1);
    }
  };

  const BREADCRUMB_STACK = [
    {
      icon: <ProcessOverview />,
      label: t("functionDetails.scenarioOverview"),
      typeOf: "",
      onClick: () => {
        navigate(SCENARIO_PATH);
      },
    },
    {
      icon: getFunctionIconFromId(inspectedFunctionId),
      label: inspectedFunction ? inspectedFunction.name : "",
      typeOf: inspectedFunction
        ? getTypeOfFunction(inspectedFunction.typeOf, t)
        : "",
      onClick: () => {},
    },
  ];

  let interval;
  let lastScrollTop = 0;

  const handleChangeProcessSearch = (e) => {
    setSearch(e.target.value);

    const searchKey = e.target.value;
    let filter = "";

    const newSearchableInspectedFunction = { ...inspectedFunction };

    let filteredInspectedFunctionData = [];

    if (searchKey !== "") {
      // Search over DB-resolved text embedded in the API response — process type
      // titles, info bullets, and subInfo. Replaces the previous t()-key lookups
      // now that content lives in the DB, not i18n.
      filteredInspectedFunctionData =
        newSearchableInspectedFunction.data.filter((process) => {
          let temp = "";
          (process.dataType || []).forEach((processType) => {
            if (processType.title) {
              temp += ` ${processType.title.toLowerCase()}`;
            }
            (processType.info || []).forEach((info) => {
              temp += ` ${(info || "").toLowerCase()}`;
            });
            if (processType.subInfo) {
              if (processType.subInfo.name) {
                temp += ` ${processType.subInfo.name.toLowerCase()}`;
              }
              if (processType.subInfo.info) {
                temp += ` ${processType.subInfo.info.toLowerCase()}`;
              }
            }
          });
          filter = searchKey.toLowerCase();
          return temp.includes(filter);
        });

      newSearchableInspectedFunction.data = filteredInspectedFunctionData;
    } else if (searchKey === "") {
      newSearchableInspectedFunction.data = inspectedFunction.data;
    }

    setSearchableInspectedFunction(newSearchableInspectedFunction);
    window.scrollTo(0, 0);
  };

  const handleOnSearchClear = () => {
    setSearch("");

    const newSearchableInspectedFunction = { ...inspectedFunction };
    newSearchableInspectedFunction.data = inspectedFunction.data;

    setSearchableInspectedFunction(newSearchableInspectedFunction);
  };

  const timeoutCallback = useCallback((event) => {
    setIsScrolling(false);
  }, []);

  const viewPortCallback = () => {
    if (inspectedFunction) {
      inspectedFunction.data.forEach((data) => {
        handleChangeActiveOption(data);
      });
    }
  };

  const handleDetectViewport = useCallback(
    (event) => {
      viewPortCallback();
      window.clearTimeout(interval);
      interval = setTimeout(timeoutCallback, 66);

      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        // setIsDownscroll(true)
      } else {
        // setIsDownscroll(false)
      }
      lastScrollTop = st <= 0 ? 0 : st;
    },
    [inspectedFunction],
  );

  useEffect(() => {
    window.addEventListener("scroll", handleDetectViewport, false);
    return () => {
      window.removeEventListener("scroll", handleDetectViewport, false);
    };
  }, [handleDetectViewport]);

  const handleChangeActiveOption = useCallback(
    (data) => {
      const element = document.getElementById(data.name);
      if (element) {
        const bounding = element.getBoundingClientRect();
        if (bounding.top >= 0 && bounding.top <= 300) {
          if (inspectedFunction) {
            setActiveOption(data.name);
            setActiveData(data);

            const sectionHash = `#menu%${data.name}`;
            window.location.hash = sectionHash;
          }
        }
      }
    },
    [inspectedFunction],
  );

  const handleRemoveFromCollection = (data) => () => {
    const newCollection = [...collection];
    const newEditorStateList = [...editorStateList];

    newCollection.forEach((c, i) => {
      if (c.name === inspectedFunction.name) {
        c.processes.forEach((p, j) => {
          if (p.name === data.name) {
            if (
              JSON.stringify(p.type) ===
              JSON.stringify(data.dataType[data.activeIndex].type)
            ) {
              c.processes.splice(j, 1);
            }

            if (c.processes.length === 0) {
              newCollection.splice(i, 1);
            }
          }
        });
      }
    });

    newEditorStateList.forEach((editor, index) => {
      if (
        editor.function_id === inspectedFunction.systemID &&
        editor.sub_function_id === data.dataType[data.activeIndex].systemID
      ) {
        newEditorStateList.splice(index, 1);
      }
    });

    AppService.updateFunctionCollection(
      userInfo.key,
      convertNotesToJSON(newCollection),
    )
      .then((res) => {
        setCollection(convertNotesToEditorState(newCollection));
        setEditorStateList(newEditorStateList);
      })
      .catch((err) => {
        handleShowErrorSnackbar(err);
      });
  };

  const handleAddToCollection = (data) => () => {
    const newCollection = [...collection];

    let isFunctionAlreadyExists = false;

    newCollection.forEach((c) => {
      if (c.name === inspectedFunction.name) {
        isFunctionAlreadyExists = true;

        if (
          c.processes.filter(
            (c) =>
              c.name === data.name &&
              JSON.stringify(c.type) ===
                JSON.stringify(data.dataType[data.activeIndex].type),
          ).length === 0
        ) {
          c.processes.push(
            new CartProcess(
              data.dataType[data.activeIndex].systemID,
              data.name,
              data.dataType[data.activeIndex].type,
            ),
          );
        } else {
          console.log("Already added to collection");
        }
      }
    });

    if (!isFunctionAlreadyExists) {
      newCollection.push(
        new Cart(
          inspectedFunction.systemID,
          inspectedFunction.name,
          inspectedFunction.icon,
          inspectedFunction.typeOf,
          [
            new CartProcess(
              data.dataType[data.activeIndex].systemID,
              data.name,
              data.dataType[data.activeIndex].type,
            ),
          ],
        ),
      );
    }

    AppService.updateFunctionCollection(
      userInfo.key,
      convertNotesToJSON(newCollection),
    )
      .then((res) => {
        setCollection(convertNotesToEditorState(newCollection));
      })
      .catch((err) => {
        handleShowErrorSnackbar(err);
      });
  };

  return (
    inspectedFunction &&
    searchableInspectedFunction && (
      <RootWrapperContainer>
        <div onScroll={handleDetectViewport} style={{ width: "100%" }}>
          <SAPNavHeader
            stacks={BREADCRUMB_STACK}
            functionType={inspectedFunction.type}
          />

          <PaddedContainer>
            <Styled.ContentLayout>
              <Styled.SidebarColumn>
                <Sidebar
                  setActiveOption={setActiveOption}
                  setActiveData={setActiveData}
                  originalMenus={inspectedFunction.data}
                  menus={searchableInspectedFunction.data}
                  search={search}
                  onSearch={handleChangeProcessSearch}
                  onClear={handleOnSearchClear}
                  activeOption={activeOption}
                  activeData={activeData}
                  isScrolling={isScrolling}
                  setIsScrolling={setIsScrolling}
                  setAppPreviewNavIndex={setAppPreviewNavIndex}
                  collection={collection}
                  handleOpenSpecialFunctionDialog={
                    handleOpenSpecialFunctionDialog
                  }
                />
              </Styled.SidebarColumn>
              {searchableInspectedFunction.data.length > 0 && (
                <Styled.MainColumn>
                  <Styled.MiddleContent>
                    {searchableInspectedFunction.data.map((func, index) => {
                      return (
                        <div
                          key={`function${index}`}
                          style={index > 0 ? { marginTop: 240 } : undefined}
                        >
                          <FunctionLists
                            func={func}
                            search={search}
                            inspectedFunction={inspectedFunction}
                            setInspectedFunction={setInspectedFunction}
                            inspectedFunctionImage={inspectedFunctionImage}
                            appPreviewNavIndex={appPreviewNavIndex}
                            setAppPreviewNavIndex={setAppPreviewNavIndex}
                            handleOpenSpecialFunctionDialog={
                              handleOpenSpecialFunctionDialog
                            }
                            setIsEditingSpecialFunction={
                              setIsEditingSpecialFunction
                            }
                            setInspectedSpecialFunctionData={
                              setInspectedSpecialFunctionData
                            }
                            handleAddToCollection={handleAddToCollection}
                            handleRemoveFromCollection={
                              handleRemoveFromCollection
                            }
                            addCollectionButton={AddCollectionButton}
                            removeCollectionButton={RemoveCollectionButton}
                            handleOpenDeleteDialog={handleOpenDeleteDialog}
                            handleAddEditorStateList={handleAddEditorStateList}
                            editorStateList={editorStateList}
                            userInfo={userInfo}
                            inspectedFunctionId={inspectedFunctionId}
                            activeOption={activeOption}
                          />
                        </div>
                      );
                    })}
                    <div style={{ height: "calc(100vh - 300px)" }} />
                  </Styled.MiddleContent>
                  <Styled.RightColumn>
                    <Styled.RightSticky>
                      <div>
                        {inspectedFunctionId ===
                          F_SONDERFUNKTIONEN_ERWEITERUNGEN && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <NewFunctionButton
                              onClick={handleOpenSpecialFunctionDialog}
                              size="small"
                            />
                          </div>
                        )}
                      </div>
                      {activeData && inspectedFunctionImage && (
                        <div>
                          {/* Old collection button code:
                          <div
                            style={{
                              visibility:
                                activeData.dataType[activeData.activeIndex]
                                  .isCollectible &&
                                inspectedFunctionId !==
                                  F_SONDERFUNKTIONEN_ERWEITERUNGEN
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            {isProcessTypeAlreadyAddedToCollection(
                              collection,
                              activeData,
                            ) ? (
                              <Styled.AddedToCollection>
                                <RemoveCollectionButton
                                  activeData={activeData}
                                  handleRemoveFromCollection={
                                    handleRemoveFromCollection
                                  }
                                />
                              </Styled.AddedToCollection>
                            ) : (
                              <Styled.AddToCollection>
                                <AddCollectionButton
                                  activeData={activeData}
                                  handleAddToCollection={handleAddToCollection}
                                />
                              </Styled.AddToCollection>
                            )}
                          </div>
                          */}
                          <AppPreview
                            inspectedFunctionImage={inspectedFunctionImage}
                            activeData={activeData}
                            appPreviewNavIndex={appPreviewNavIndex}
                            setAppPreviewNavIndex={setAppPreviewNavIndex}
                            handleCarouselNavOnClick={handleCarouselNavOnClick}
                            handleLeftArrowOnClick={handleLeftArrowOnClick}
                            handleRightArrowOnClick={handleRightArrowOnClick}
                            isOpen={isPreviewOpen}
                            setIsOpen={setIsPreviewOpen}
                          />
                        </div>
                      )}
                    </Styled.RightSticky>
                  </Styled.RightColumn>
                </Styled.MainColumn>
              )}
            </Styled.ContentLayout>
            {(searchableInspectedFunction.data.length === 0 ||
              inspectedFunction.data.length === 0) && (
              <Styled.NoDataLayout>
                {inspectedFunction.data.length === 0 ? (
                  <Copy
                    style={{
                      width: 134,
                      height: 134,
                      color: ColorSAP.primary[20],
                    }}
                  />
                ) : (
                  <Search
                    style={{
                      width: 134,
                      height: 134,
                      color: ColorSAP.primary[20],
                    }}
                  />
                )}
                <Typography
                  fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD}
                  size={36}
                  color={ColorSAP.primary[100]}
                  style={{ marginBottom: 30 }}
                >
                  {inspectedFunction.data.length === 0
                    ? `${t("functionDetails.noCustomAvailable")}`
                    : `${t("common.noSearchResult")}`}
                </Typography>
                {inspectedFunction.data.length === 0 &&
                  inspectedFunctionId ===
                    "F_SONDERFUNKTIONEN_ERWEITERUNGEN" && (
                    <Button
                      type="primary"
                      theme="dark"
                      size="small"
                      onClick={handleOpenSpecialFunctionDialog}
                    >
                      {t("functionDetails.newFunction")}
                    </Button>
                  )}
              </Styled.NoDataLayout>
            )}
          </PaddedContainer>

          <SpecialFunctionDialog
            open={specialFunctionDialogOpen}
            onClose={handleCloseSpecialFunctionDialog}
            isEditing={isEditingSpecialFunction}
            func={inspectedSpecialFunctionData}
          />

          <DeleteDialog
            open={deleteDialogOpen}
            onClose={handleCloseDeleteDialog}
            onDelete={handleDeleteSpecialFunction}
            title={"Function"}
            dataName={
              inspectedSpecialFunctionData && inspectedSpecialFunctionData.name
            }
          />
        </div>
      </RootWrapperContainer>
    )
  );
};

export default ConfigurationContainer;
